export default "<div class=\"wrapper wrapper-full-page\">\r\n  <router-outlet></router-outlet>\r\n</div>"